import axiosClient from "./axiosClient";

const customerCare = {
  // Nation
  getLitCustomerCare: async (params) => {
    const url = "/qlkhambenh/phieu-cskh/list-phieu-cskh";
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  postCustomerCare: async (data) => {
    const url = `/qlkhambenh/phieu-cskh`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  updateCustomerCare: async (id, data) => {
    const url = `/qlkhambenh/phieu-cskh?id=${id}`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  getDetailsCustomerCare: async (id) => {
    const url = `/qlkhambenh/phieu-cskh?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  deleteDetailsCustomerCare: async (id) => {
    const url = `/qlkhambenh/phieu-cskh/lich-su?idLichSu=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },

  updateStatusDetail: async (param) => {
    const url = `/qlkhambenh/phieu-cskh/cap-nhat-trang-thai`;
    const response = await axiosClient.put(url, {}, { params: param });
    return response.data;
  },

  //danh mục
  getDetailById: async (id) => {
    const url = `/qlkhambenh/dm-trang-thai-cskh?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  postDetailById: async (data) => {
    const url = `/qlkhambenh/dm-trang-thai-cskh`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  putDetailById: async (data) => {
    const url = `/qlkhambenh/dm-trang-thai-cskh?id=${data.id}`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  deleteDetailById: async (id) => {
    const url = `/qlkhambenh/dm-trang-thai-cskh?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
};

export default customerCare;
